import React, { createContext, type ReactElement, useContext } from 'react';
import concatClassNames from 'utils/classNames';
import { type IClassName } from 'types/common/Props';
import ProfileSidebar from 'components/profile/profile-sidebar/ProfileSidebar';
import useWindowWidth from 'hooks/useWindowWidth';
import { useGetCustomerDetailsQuery } from 'store/api/customerApi';
import { type IPage } from '../../types/IPage';
import PageSeoSection from '../../components/page-seo-section/PageSeoSection';
import './Profile.scss';

interface IProfile extends IClassName {
  pageSeo?: IPage
  /** Visually hidden heading 1 for pages whose database row has none (every page needs exactly one h1). */
  fallbackHeading1?: string
  containerClassName?: string
  children: ReactElement | ReactElement[]
}

const CustomerDetailsContext = createContext<any>({});

export const useCustomerDetails = () => useContext(CustomerDetailsContext);

const Profile = ({ className, containerClassName, pageSeo, fallbackHeading1, children }: IProfile) => {
  const { data: customerDetails, refetch } = useGetCustomerDetailsQuery();
  const { isMobile, isSmallTablet } = useWindowWidth();

  const shouldRenderSidebar = !isMobile && !isSmallTablet;

  return (
    <CustomerDetailsContext.Provider value={{ customerDetails, refetch }}>
      <section className={concatClassNames(className, 'flex profile')}>
        {shouldRenderSidebar && <ProfileSidebar/>}
        <div className={containerClassName}>
          {(pageSeo || fallbackHeading1) && <PageSeoSection pageSeo={pageSeo} fallbackHeading1={fallbackHeading1} className="page-seo"/>}
          <div className="profile-content">
            {children}
          </div>
        </div>
      </section>
    </CustomerDetailsContext.Provider>
  );
};

export default Profile;
